import React, { useState } from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import TreeView from "@material-ui/lab/TreeView";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import MaterialTreeItem from "@material-ui/lab/TreeItem";
import { Formik, useField } from "formik";
import { FormControlLabel, Checkbox } from "@material-ui/core";
import FolderIcon from "@material-ui/icons/FolderOpenTwoTone";
import FolderOpenIcon from "@material-ui/icons/FolderOpen";
import MemoryIcon from "@material-ui/icons/Memory";
import BlurCircularIcon from "@material-ui/icons/BlurCircular";
import { useSelector } from "react-redux";

const initialValues = {};

const useStyles = makeStyles({
  root: {
    height: 110,
    flexGrow: 1,
    maxWidth: 400
  },
  folderPadding: {
    padding: '22px 5px 15px',
    // margin: "0px !important"
  },
  treeCss: {
    marginTop: '-9px'
  }
  // '& .MuiCheckbox-colorSecondary.Mui-checked':{
  //   color: "#007bff !important"
  // }


});

const TreeItem = withStyles((theme)=> ({
  root: {
    "&.Mui-selected > .MuiTreeItem-content .MuiTreeItem-label": {
      backgroundColor: '#26262600 !important',
    }
  },
}))(MaterialTreeItem);


const FolderTreeStructure = ({ treeData, parentCallBack, dbName, dataArray, seQValue, pageType, expandedIds }) => {
  const classes = useStyles();
  const [files, setFiles] = useState([]);
  const toggle = useSelector(state => state.setToggle.toggle);
  expandedIds = expandedIds ? expandedIds : [];

  const renderTree = (nodes, onSelect, dbName, dataArray, seQValue, pageType) =>
    <TreeItem style = {{marginTop: '-12px'}}
      key={nodes.id}
      nodeId={nodes.id}
      label={
        <div className= {classes.treeCss}>
          {(nodes.type === "seqdb" || nodes.type === "vseqdb") ? (
            <>
              {pageType && pageType == "ipseqvar" && <FormControlLabel 
                control={
                  <Checkbox
                    name="file"
                    checked={dataArray.includes(nodes.id)}
                    onChange={e => {
                      onSelect(nodes.label, e.target.checked);
                      parentCallBack(nodes.id, dbName)
                    }}
                    disabled={seQValue == dbName ? false : true}
                    style={{ color: (toggle ? '': '#aea9a9' )}}      />
                }
                label={nodes.type == "seqdb" ? nodes.label : nodes.label+" ⁽ᵛ⁾"}
                key={nodes.id}
              />
              }
              {pageType && pageType == "ipseq" && <FormControlLabel
                control={
                  <Checkbox
                    name="file"
                    checked={dataArray.includes(nodes.id)}
                    onChange={e => {
                      onSelect(nodes.label, e.target.checked);
                      parentCallBack(nodes.id, dbName)
                    }}
                    style={{ color: (toggle ? '': '#aea9a9' )}}                  />
                }
                label={nodes.type == "seqdb" ? nodes.label : nodes.label+" ⁽ᵛ⁾"}
                key={nodes.id}
              />
              }
            </>
          ) : null}
          {nodes.type === "folder" ? (
            <div className={classes.folderPadding}>
              {nodes.label}
            </div>
          ) : null}
        </div>
      }
    // onLabelClick={() => {
    // onSelect(nodes.type, nodes.label);
    // parentCallBack(nodes.id, dbName)
    // }}
    // onIconClick={() => {
    // onSelect(nodes.type, nodes.label)
    // parentCallBack(nodes.id, dbName)
    // }}
    >
      {Array.isArray(nodes.children)
        ? nodes.children.map(node => renderTree(node, onSelect, dbName, dataArray, seQValue, pageType))
        : null}
    </TreeItem>
  // );

  //   initialValues["yellow"] = data.name;

  return (
    <Formik className={classes.root} initialValues={initialValues}>
      {props => (
        <>
          <Tree
            data={treeData}
            setFieldValue={props.setFieldValue}
            renderTree={renderTree}
            expandedIds={expandedIds}
            dbName={dbName}
            dataArray={dataArray}
            seQValue={seQValue}
            pageType={pageType}
          />
          {/* <pre>{JSON.stringify(props.values, null, 2)}</pre> */}
        </>
      )}
    </Formik>
  );

};

export default FolderTreeStructure;

const Tree = (props) => {
  const [data] = React.useState();
  return (
    <>
      <TreeView
        defaultCollapseIcon={<ExpandMoreIcon style={{color: 'darkgrey'}}/>}
        //defaultExpanded={["root"]}
        defaultExpanded={props.expandedIds}
        expanded={data}
        defaultExpandIcon={<ChevronRightIcon style={{color: 'darkgrey'}}/>}
        multiSelect
        dbName
        dataArray
        seQValue
        pageType
      >
        {props.renderTree(props.data, props.setFieldValue, props.dbName, props.dataArray, props.seQValue, props.pageType)}
      </TreeView>
      {/* <pre>{JSON.stringify(props.values, null, 2)}</pre> */}
    </>
  );
};
